{
    "actions": {
        "page": {
            "create_envelopes": {
                "title": "Create envelopes",
                "select": "Create by selection",
                "upload": "Create from CSV file"
            },
            "create_download_code": "Create download code",
            "deprogram": "Deprogram"
        },
        "row": {
            "update_download_code": "Update"
        }
    },
    "filter": {
        "placeholder": {
            "envelopes": {
                "access_code": "Filter by access code",
                "client_name": "Filter by client",
                "download_server_ip_address_port": "Filter by server IP",
                "serial_number": "Filter by serial"
            },
            "download_codes": {
                "code_name": "Filter by code name",
                "created_by": "Filter by creator"
            }
        }
    },
    "form": {
        "placeholder": {
            "end_date": "No expiration",
            "start_date": "Upon receipt",
            "access_code": "4 to 9 numbers (ex: 1234)",
            "server_ip": "ex: 121.122.123.124:10000",
            "code_name": "ex: Migration campaign FRV6 Move 5000"
        }
    },
    "keys": {
        "envelopes": {
            "access_code": "Access code",
            "client": "Client",
            "code_name": "Code name",
            "created_at": "Created at",
            "schedule_start": "Schedule start",
            "schedule_end": "Schedule end",
            "sent_at": "Sent at",
            "serial_number": "Serial#",
            "server_ip": "Server IP",
            "status": "Status"
        },
        "download_codes": {
            "created_at": "Cretaed at",
            "created_by": "Created by"
        }
    },
    "modal": {
        "create_envelopes": {
            "select_csv": "Import by file",
            "select_form": "Form (20 TPE maximum)",
            "title": "Create envelopes",
            "success": "Operation successful!",
            "terminal_serial_numbers": "{{numberOfSelectedItems}} POS terminals selected",
            "steps": {
                "client_selection": "Step {{step}} of {{maxStep}}: Select a client",
                "pos_terminal_selection": "Step {{step}} of {{maxStep}}: Select terminals",
                "form_fill": "Step {{step}} of {{maxStep}}: Fill in the form"
            }
        },
        "import": {
            "explanations": {
                "header": "You can schedule multiple download envelopes at the same time. The file to upload must contain the following 6 columns :",
                "serial_number": "Serial number of the terminals",
                "client": "Client Name",
                "start_date": "Start date of programming",
                "end_date": "End date of programming",
                "access_code": "Access code",
                "server_ip": "Server IP"
            },
            "confirmation": {
                "single": "{{numberOfEnvelopes}} envelope will be created. Do you want to continue?",
                "multiple": "{{numberOfEnvelopes}} envelopes will be created. Do you want to continue?"
            },
            "error": {
                "BAD_FORMAT": "The file is not in the correct format.",
                "BAD_FILE_FORMAT": "The file is not in the correct format.",
                "UNEXPECTED_ERROR": "An unexpected error occurred.",
                "INTERNAL_SERVER_ERROR": "An internal server error occurred.",
                "invalid_file": "This file is not compatible (.csv only)",
                "get_example_file": "Feel free to download our template file to help you fill it in.",
                "csvBadLineFormat": {
                    "single": "{{linesNumber}} line in file is not in the correct format.",
                    "multiple": "{{linesNumber}} lines in file are not in the correct format.",
                    "all": "All lines in file are not in the correct format."
                },
                "scheduledDatesInThePast": "Envelopes cannot be scheduled for past dates. Please enter future start and end dates or leave the fields blank.",
                "alreadyExistingSerialNumberInCsv": "The line for this terminal is duplicated in the provided file. The envelope was created and duplicates were then discarded.",
                "serialNumbersNotFound": {
                    "single": "Terminal not found, please check the entered serial number.",
                    "multiple": "Terminals not found, please check the entered serial number."
                },
                "existingEnvelope": {
                    "single": "There is already an envelope programmed for this terminal. Please delete it before programming a new one.",
                    "multiple": "There is already an envelope programmed for these terminals. Please delete it before programming a new one."
                },
                "notFoundOrganization": {
                    "single": "Client not found, please check that the entry exactly matches the name of the organization.",
                    "multiple": "Clients not found, please check that the entry exactly matches the name of the organizations."
                },
                "unauthorizedProviderForSerialNumbers": "Targeted organization for envelope creation is not available.",
                "manyOrganizationsWithSameName": {
                    "single": "An organization name matches several different organizations. Envelope creation is only possible for organizations with a unique name. We invite you to change the name of the organizations and start the envelope creation again.",
                    "multiple": "Some organizations names match several different organizations. Envelope creation is only possible for organizations with a unique name. We invite you to change the name of the organizations and start the envelope creation again."
                },
                "posList": "{{posTerminalList}}",
                "clientList": "{{clientList}}",
                "organizationList": "{{organizationNameList}}"
            },
            "message": "Please upload the example file.",
            "success": "Envelopes created successfully!"
        },
        "create_download_code": {
            "title": "Fill the form",
            "success": "Operation successful!"
        },
        "deprogram": {
            "title": "Deprogram",
            "message_single": "This operation will deprogram {{number}} envelope. Do you want to continue?",
            "message_many": "This operation will deprogram {{number}} envelopes. Do you want to continue?",
            "success": "Operation successful!",
            "steps": {
                "envelopes_selection": "Step {{step}} of {{maxStep}}: Select envelopes",
                "confirm": "Step {{step}} of {{maxStep}}: Confirm deprogramming"
            },
            "error": {
                "not_deleted_single": "Following envelope could not be deprogrammed.",
                "not_deleted_multiple": "Following envelopes could not be deprogrammed.",
                "unknown_error": "An error occurred while deprogramming"
            }
        },
        "update_download_code": {
            "success": "Download Code updated successfully!"
        },
        "errors": {
            "ALREADY_EXISTING_ACCESS_OR_CODE_NAME": "Operation failed, campaign or access code already exist.",
            "UNKNOWN_ERROR": "An unknown error occurred."
        }
    },
    "status": {
        "SCHEDULED": "Scheduled",
        "SENT": "Sent",
        "ERROR": "Error"
    }
}